import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import SearchViewHeader from './search-view-header';
import SearchViewList from './search-view-list';
import { View } from '@dbk/ui-react-utils';
import Button from '@dbk/ui-buttons';
import { NotificationWarning } from '@dbk/ui-icons';
import BlurModal from '../../../../src/components/common/blur-modal';

class RMSearchContainer extends PureComponent {
    constructor(props) {
        super(props);
    }   
    componentDidMount() {
        this.props.setAuthorised(false);
        this.props.setLangToEn();
    }

    componentWillUnmount() {
        this.props.rmAccess.setLoader(false);
        this.props.rmAccess.resetSearchVariables();
    }

    closeBlurModel = async () => {
        //   await this.props.rmAccess.resetSearchVariables();
        await this.props.rmAccess.setShowErrorModal(false);
    };

    renderErrorModal = () => {
        const { i18n: { messages },
            rmAccess: { showContractList, showErrorModal, errorTitle, blurModalError } } = this.props;

        return (
            <BlurModal
                visible={showErrorModal}
                doneVisible={false}
                title={<h4>{errorTitle}</h4>}
                onDone={() => this.closeBlurModel()}
            >
                <div className="error-message-container">
                    <NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
                    <span className="error-message-content">{this.props.rmAccess.errorMsg}</span>
                </div>
            </BlurModal>
        )
    }

    render() {
        const { i18n: { messages },
            rmAccess: { showContractList, showErrorModal, errorTitle, blurModalError } } = this.props;
        return (
            <div className="rm-search_background ">
                <div className="rm-search__container">
                    <div className={showContractList ? "full-container rm-search" : "half-container rm-search"}>
                        <SearchViewHeader />
                        {showContractList && <SearchViewList />}
                        {showErrorModal && this.renderErrorModal()}
                    </div>
                </div>
            </div>

        );
    }

}

export default createContainer({
    $queries: {
        i18n: {
            messages: true,
        },
        setLangToEn: { $call: 'language.setLanguageValue'},
        rmAccess: {
            setLoader: { $set: 'showSpinner' },
            showSpinner: true,
            showContractList: true,
            showErrorModal: true,
            errorMsg: true,
            errorTitle: true,
            setShowErrorModal: { $set: 'showErrorModal' },
            resetSearchVariables: { $call: 'resetSearchVariables' }
        },
        setAuthorised: { $call: 'auth.setAuthorised' },

    }
})(RMSearchContainer);
